module.exports = __webpack_public_path__ + "media/Please be true.00865477.mp4";